module.exports = __webpack_public_path__ + "assets/img/202109-3.31c1d5f4.png";